query GetContactRecordTypes {
  contactRecordTypes {
    id
    name
    description
    salesforceId
  }
}
